export const TOKEN_STORAGE_KEY = 'daccelerate_new_token'
export const IMPERSONATE_STORAGE_KEY = 'daccelerate_impersonate_target'
